import React from "react";
import {  Statistic, Card, Row, Col } from 'antd'
import { UserIcon } from "../Icon";
import { Typography, Button, List } from 'antd';
import {Avatar} from "@webiz/admin-design-system";
const { Text, Paragraph } = Typography;


const TopArtists = () => {
  const arr = [
    {
      name: 'Joy',
      email: 'joyblabla@gmail.com',
      price: '12,000',
    },
    {
      name: 'Joy',
      email: 'joyblabla@gmail.com',
      price: '12,000',
    },
    {
      name: 'Joy',
      email: 'joyblabla@gmail.com',
      price: '12,000',
    },
    {
      name: 'Joy',
      email: 'joyblabla@gmail.com',
      price: '12,000',
    },
    {
      name: 'Joy',
      email: 'joyblabla@gmail.com',
      price: '12,000',
    },
    {
      name: 'Joy',
      email: 'joyblabla@gmail.com',
      price: '12,000',
    },
  ]
  return (
    <div className="top-artists-card">
      <Card className="card-content">
        <Text className="artists-header">Top Artists</Text>
        <Card type="inner" title={
        <div className="inner-title">
          <Text>Clients</Text>
        <div className = 'artist-buttons'>  
          <Button className="earnings-button ">Earnings</Button>
          <Button className="active-subs-button ">Active Subs</Button>
        </div>  
        </div>
        }>
         <div>
            {arr.map(obj => (
              <div className="card-cols">
                <div className="card-three-elements">
                  <Avatar size="xs"/>  
                  <Text className="artist-name">{obj.name}</Text>
                  <Text className="artist-email">{obj.email}</Text>
                </div>
                <Text className="artist-price">${obj.price}</Text>
              </div>
            ))}
          </div>
          <div className="card-btn-container">
            <Button className="card-btn" type="link">View All</Button>
          </div> 
  
        </Card>
      </Card>
</div>
  )
}

export default TopArtists;
